import React from 'react'
import { faBox } from '@fortawesome/pro-solid-svg-icons/faBox'
import { faBoxOpen } from '@fortawesome/pro-solid-svg-icons/faBoxOpen'
import { CircleIcon } from '../CircleIcon'
import translations from 'constants/translations'
import styles from './styles.module.scss'

interface EmptyList {
  loading?: boolean
  locale?: string
}

const EmptyList: React.FC<EmptyList> = ({ loading = false, locale }) => (
  <div className={`emptyList ${styles.emptyList}`}>
    <div className="emptyListIconContainer">
      <CircleIcon className="emptyListIcon" icon={!loading ? faBoxOpen : faBox} size="3x" />
    </div>
    <div className="emptyListText" style={{ color: '#aaa9a9' }}>
      {!loading && (locale || translations.table.emptyMessage)}
    </div>
  </div>
)

export default EmptyList
